(function () {
  'use strict';

  angular
    .module('multipleFlightsInRollingSevenDays')
    .service('multipleFlightsInRollingSevenDaysService', multipleFlightsInRollingSevenDaysService);

  function multipleFlightsInRollingSevenDaysService(CommonMasterData,RemoteService) {
    var vm = this;

    vm.searchMultipleFlightsInRollingSevenDays = function (param ,successFn,errorFn) {
      var searchParam = adaptSearchRequset(param);
      RemoteService.searchMultipleFlightsInRollingSevenDays(searchParam).then(
        function (response) {
          successFn(response);
        },
        function (error) {
          errorFn(error.msg);
        }
      );
    };

    function adaptSearchRequset(param) {
      const airportCodeList = [];
      if (param.destinations != null){
        param.destinations.forEach(function(airport){
          airportCodeList.push(airport.airPortCode);
        })
      }
      var actualSearchParam = {
        fromDate : param.fromDate,
        toDate: param.toDate,
        crewType:(param.crewType !=null ) ? param.crewType.crewTypeCode:null,
        crewBase:(param.base !=null) ? param.base.airPortCode:null,
        autoOrManual: (param.autoOrManual != null) ? param.autoOrManual.autoOrManualCode:null,
        destinationList: (param.destinations != null) ? airportCodeList:null,
      };

      return actualSearchParam;
    }

  }
}());
